import * as Yup from "yup";

export const EXTRA_TYPE_OPTIONS = (t) => [
  {
    id: "decorative_extra",
    name: t("wrappers_wrap_extras.extra_type_decorative"),
  },
  {
    id: "personal_touch",
    name: t("wrappers_wrap_extras.extra_type_personal_touch"),
  },
  {
    id: "both",
    name: t("wrappers_wrap_extras.extra_type_both"),
  },
];

const CLEARED_TEXT_SETTINGS = {
  requires_text: false,
  text_max_length: "",
  text_placeholder_en: "",
  text_placeholder_ar: "",
};

export const initialValues = (data) => {
  return {
    ...data,
    ...data?.localized_data,
    purchasable: data?.purchasable,
    track_inventory: data?.track_inventory,
    category_ids:
      data?.categories?.map((c) => ({ label: c.name, value: c.id })) || [],
    for_whole_cart: data?.for_whole_cart || false,
    extra_type: data?.extra_type || "",
    requires_text: data?.requires_text ?? false,
    text_max_length: data?.text_max_length ?? "",
    text_placeholder_en:
      data?.text_placeholder_en ||
      data?.localized_data?.en?.text_placeholder ||
      "",
    text_placeholder_ar:
      data?.text_placeholder_ar ||
      data?.localized_data?.ar?.text_placeholder ||
      "",
    display_priority: data?.display_priority ?? "",
  };
};

export const structure = (
  t,
  categories,
  fetchCategories,
  categoriesLoading,
  categoriesCount,
  extraType,
  requiresText,
) => {
  const showTextSettings =
    extraType === "personal_touch" || extraType === "both";

  return [
    {
      head: "",
      width: "100%",
      list: [
        {
          name: `image`,
          kind: "upload",
          type: "image",
          label: `${t("wrappers_wrap_extras.wrap_photo")}*`,
          placeholder: t("wrappers_wrap_extras.upload_placeholder"),
          text: t("wrappers_wrap_extras.file_size_limit"),
          width: "47%",
        },

        {
          width: "47%",
        },
        {
          name: `en.name`,
          kind: "input",
          type: "text",
          label: `${t("wrappers_wrap_extras.name_en")}*`,
          width: "47%",
          placeholder: t("wrappers_wrap_extras.write_name_en"),
        },
        {
          name: `ar.name`,
          kind: "input",
          type: "text",
          label: t("wrappers_wrap_extras.name_ar"),
          width: "47%",
          placeholder: t("wrappers_wrap_extras.write_name_ar"),
        },

        {
          name: `price`,
          kind: "input",
          type: "number",
          label: `${t("wrappers_wrap_extras.price")}*`,
          width: "47%",
          placeholder: t("wrappers_wrap_extras.write_price"),
          EndAdornment: (
            <p style={{ fontSize: "18px", color: "#1A1A1A" }}>SAR</p>
          ),
        },

        {
          name: `price_after_discount`,
          kind: "input",
          type: "number",
          label: `${t("wrappers_wrap_extras.price_after_discount")}*`,
          width: "47%",
          placeholder: t("wrappers_wrap_extras.write_price"),
          EndAdornment: (
            <p style={{ fontSize: "18px", color: "#1A1A1A" }}>SAR</p>
          ),
        },
        {
          name: `count_on_hand`,
          kind: "input",
          type: "number",
          label: t("wrappers_wrap_extras.quantity"),
          width: "47%",
          placeholder: t("wrappers_wrap_extras.write_quantity"),
        },
        {
          name: `width`,
          kind: "input",
          type: "number",
          label: `${t("wrappers_wrap_extras.width")}*`,
          width: "47%",
          placeholder: t("wrappers_wrap_extras.write_width"),
          EndAdornment: (
            <p style={{ fontSize: "18px", color: "#1A1A1A" }}>gm</p>
          ),
        },
        {
          name: `height`,
          kind: "input",
          type: "number",
          label: `${t("wrappers_wrap_extras.height")}*`,
          width: "47%",
          placeholder: t("wrappers_wrap_extras.write_height"),
          EndAdornment: (
            <p style={{ fontSize: "18px", color: "#1A1A1A" }}>cm</p>
          ),
        },
        {
          name: `length`,
          kind: "input",
          type: "number",
          label: `${t("wrappers_wrap_extras.length")}*`,
          width: "47%",
          placeholder: t("wrappers_wrap_extras.write_length"),
          EndAdornment: (
            <p style={{ fontSize: "18px", color: "#1A1A1A" }}>cm</p>
          ),
        },

        {
          name: `weight`,
          kind: "input",
          type: "number",
          label: `${t("wrappers_wrap_extras.weight")}*`,
          width: "47%",
          placeholder: t("wrappers_wrap_extras.write_weight"),
          EndAdornment: (
            <p style={{ fontSize: "18px", color: "#1A1A1A" }}>gm</p>
          ),
        },
        {
          name: `category_ids`,
          kind: "multiSelect",
          label: t("products.label_recommended_categories"),
          width: "47%",
          placeholder: t("products.placeholder_choose_categories"),
          options: categories,
          onOpen: categories?.length <= 1 && fetchCategories,
          isLoading: categoriesLoading,
          getList: fetchCategories,
          count: categoriesCount,
        },
        {
          name: `extra_type`,
          kind: "select",
          type: "text",
          label: t("wrappers_wrap_extras.extra_type"),
          width: "47%",
          placeholder: t("wrappers_wrap_extras.choose_extra_type"),
          options: EXTRA_TYPE_OPTIONS(t),
          changeAction: (value, formik) => {
            const allowText =
              value === "personal_touch" || value === "both";
            formik.setValues({
              ...formik.values,
              extra_type: value,
              ...(allowText ? {} : CLEARED_TEXT_SETTINGS),
            });
          },
        },
        {
          name: `display_priority`,
          kind: "input",
          type: "number",
          label: t("wrappers_wrap_extras.display_priority"),
          width: "47%",
        },
        {
          name: `for_whole_cart`,
          kind: "checkbox",
          label: t("wrappers_wraps.for_whole_cart") || "For Whole Cart",
          width: "fit-content",
        },
        {
          name: `purchasable`,
          kind: "checkbox",
          label: t("wrappers_wrap_extras.purchasable"),
          width: "fit-content",
        },
        {
          name: `track_inventory`,
          kind: "checkbox",
          label: t("wrappers_wrap_extras.track_inventory"),
          width: "fit-content",
        },
        showTextSettings && {
          name: `requires_text`,
          kind: "checkbox",
          label: t("wrappers_wrap_extras.requires_text"),
          width: "fit-content",
          changeAction: (value, formik) => {
            formik.setValues({
              ...formik.values,
              requires_text: value,
              ...(value
                ? {}
                : {
                    text_max_length: "",
                    text_placeholder_en: "",
                    text_placeholder_ar: "",
                  }),
            });
          },
        },
        showTextSettings &&
          requiresText && {
            name: `text_max_length`,
            kind: "input",
            type: "number",
            label: t("wrappers_wrap_extras.text_max_length"),
            width: "47%",
            placeholder: t("wrappers_wrap_extras.write_text_max_length"),
          },
        showTextSettings &&
          requiresText && {
            name: `text_placeholder_en`,
            kind: "input",
            type: "text",
            label: t("wrappers_wrap_extras.text_placeholder_en"),
            width: "47%",
            placeholder: t("wrappers_wrap_extras.write_text_placeholder_en"),
          },
        showTextSettings &&
          requiresText && {
            name: `text_placeholder_ar`,
            kind: "input",
            type: "text",
            label: t("wrappers_wrap_extras.text_placeholder_ar"),
            width: "47%",
            placeholder: t("wrappers_wrap_extras.write_text_placeholder_ar"),
          },
      ].filter(Boolean),
    },
  ];
};

export const validationSchema = (extraType) => {
  const showTextSettings =
    extraType === "personal_touch" || extraType === "both";

  return Yup.object({
    en: Yup.object().shape({
      name: Yup.string().required("Required"),
    }),
    price: Yup.number().required("required"),
    price_after_discount: Yup.number().required("required"),
    image: Yup.string().required("Required"),
    height: Yup.number().required("required"),
    length: Yup.number().required("required"),
    weight: Yup.number().required("required"),
    width: Yup.number().required("required"),
    category_ids: Yup.array(),
    for_whole_cart: Yup.boolean(),
    extra_type: Yup.string().nullable(),
    requires_text: Yup.boolean(),
    text_max_length: showTextSettings
      ? Yup.number()
          .typeError("Must be a number")
          .nullable()
          .when("requires_text", {
            is: true,
            then: (schema) =>
              schema
                .required("required")
                .min(1, "Must be at least 1")
                .max(200, "Must be at most 200"),
            otherwise: (schema) => schema.nullable(),
          })
      : Yup.number().typeError("Must be a number").nullable(),
    text_placeholder_en: Yup.string().nullable(),
    text_placeholder_ar: Yup.string().nullable(),
    display_priority: Yup.number().typeError("Must be a number").nullable(),
  });
};
